<template>
  <!-- ヘッダー -->
  <v-app-bar app clipped-left>

          <div class="d-flex align-center" style="height: 80px;">
            <router-link to="/" class="logo-link" aria-label="ホームへ">
              <img class="logo-img" src="/img/logo_kouhoku.png" alt="Clinic Logo">
            </router-link>
          </div>
          <v-row justify="space-between" class="d-flex align-center">
              <v-col cols="12" class="d-flex align-center">
                <div class="ml-auto mr-8" style="padding-top: 8px;">
                <v-menu transition="scroll-y-transition" offset-y
                              v-if="not_login_page"
                >
                  <template v-slot:activator="{ on }"

                  >
                    <v-badge
                              class="mybadge"
                              color="pink"
                              :content="messages"
                              :value="messages"
                              style=""
                            >
                        <img v-on="on" class="img bell" src="/img/icon_bell.svg" style="width: 24px;" />
                    </v-badge>
                  </template>
                  <v-list class="oshirase"
                  >
                    <v-list-item v-if="messages==0">
                      <v-list-item-title class="text_right">お知らせはありません</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-else>
                      <v-list-item-title class="text_right"><div>新規お知らせがあります</div><div class="kidoku" @click="readNotice()">既読にする</div></v-list-item-title>
                    </v-list-item>
                    <hr v-if="messages!=0" role="separator" aria-orientation="horizontal" class="v-divider theme--light">
                    <v-list-item v-for="notice in $store.getters.notices" :key="notice.id" class="border_bottom">
                      <v-list-item-title class="myleft" v-html=" toBr(notice.message) "></v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                </div>
                <v-menu offset-y  transition="scroll-y-transition"
                    v-if="not_login_page"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="user_btn">
                      <i aria-hidden="true" class="v-icon notranslate v-icon--left material-icons theme--light"><img class="img" src="/img/icon_user.svg" style="width: 24px;" /></i>
                      {{user_name}}
                      <v-icon right>mdi-triangle-small-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="logout">
                    <v-list-item v-for="menu in menus" :key="menu.no" link @click="logout">
                      <v-list-item-title class="text_right">{{ menu.name }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
          </v-row>
  </v-app-bar>
</template>

<script>
import mycolor from '@/mycolor.js';
import myMixin from '@/mixin.js';
import {mapGetters} from 'vuex'
//import axios from 'axios';

export default{
    name: 'NavComponent',
    mixins: [myMixin],


    data(){  // datas
        return {
            menus: [{no:1, name:'ログアウト', icon:'mdi-clipboard-account'}],
        }
    },
    created(){
         console.log('%c created: NavComponent.vue', mycolor.created);
    },// created

    computed: {
      ...mapGetters(['user', 'user_name', 'is_admin']),
      messages(){
          return this.$store.getters.notices.length;
      },

      not_login_page() {
          return this.$route.name!=='login';
      }
    },
    methods: {

        toBr(v){
          return v.replace(/\n/mg, '<br>');
        },
        logout(){
            console.log('logout()');
            console.log('this.$route', this.$route.path);
            localStorage.clear('user');
            this.$store.dispatch( 'user', null );
            this.$store.dispatch( 'notices', [] );
            this.$router.push( { name:'login', query:{from: this.$route.name} } ).catch(()=>{});

        },
      }
}
</script>

<style scoped>
.v-menu__content{
    max-height: 800px !important;
}
/deep/ .logout{
    overflow-y: hidden !important;
}
.logo-link{
    display: inline-flex;
    align-items: center;
    height: 80px; /* ヘッダーと同じ高さ */
    text-decoration: none;
}
.logo-img{
    height: 60px; /* 以前の見た目に近い固定値（約80px * 0.74） */
    margin-left: 36px;
    margin-top: -7px;
    padding-left: 0;
    cursor: pointer;
}
</style>
